const regionalAgency = {
  name: "Atlanta Passport Agency",
  address: "805 Broadway, Nashville, TN 37203",
  distance: "50 miles from Clarksville — appointments required, typically booked 2+ weeks out",
};

const rows = [
  {
    feature: "Appointment Required",
    agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted",
    fpc: "No appointment needed to start",
  },
  {
    feature: "In-Person Visit",
    agency: "Required — drive 50 miles to Atlanta Passport Agency in downtown Nashville",
    fpc: "Most Clarksville residents ship documents overnight",
  },
  {
    feature: "Processing Speed",
    agency: "Life-or-death emergencies only — strict eligibility with proof of travel",
    fpc: "As fast as 24 hours — multiple speed options from emergency to standard expedited",
  },
  {
    feature: "Document Review",
    agency: "None — errors cause rejection and delay",
    fpc: "Professional review to reduce processing delays",
  },
  {
    feature: "Courier Access",
    agency: "Not available to the public — agency serves emergencies only",
    fpc: "Reserved daily submission availability as registered courier",
  },
  {
    feature: "Military Deployment Docs",
    agency: "Self-navigate — no military-specific guidance at the post office or agency",
    fpc: "Fort Campbell and 101st Airborne expertise built in — PCS orders, deployment leave, OCONUS assignments handled routinely",
  },
  {
    feature: "Predictability",
    agency: "Appointments can be cancelled or unavailable — no guarantee of service",
    fpc: "Predictable processing based on selected speed option",
  },
  {
    feature: "Who Can Use It",
    agency: "Strict eligibility — urgent travel only with proof of departure date",
    fpc: "Most U.S. citizens with required documentation — families, students, military, and business travelers",
  },
  {
    feature: "Cost vs Resellers",
    agency: "Government fees only — but you handle all shipping and logistics yourself",
    fpc: "Best price guarantee — 30–100% less than FedEx, Staples & resellers",
  },
];

export default function ClarksvilleComparisonSection() {
  return (
    <section id="comparison" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Emergency Passports</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Regional Passport Agency vs. Fast Passport Center
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            If you need your passport <strong className="text-[#1A365D]">within two weeks</strong>, the {regionalAgency.name} is your only do-it-yourself option — {regionalAgency.distance}. Getting an appointment there is rarely straightforward. Fast Passport Center gives you a faster, simpler path without the uncertainty.
          </p>
        </div>

        {/* Passport Agency Appointment Not Available Callout */}
        <div className="mb-8 bg-amber-50 border border-[#F6C344]/40 rounded-lg p-6">
          <h3 className="font-serif text-lg font-bold text-[#1A365D] mb-3">
            Clarksville Passport Agency Appointment Not Available?
          </h3>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Regional passport agency appointments are routinely booked 2–4 weeks out — and walk-ins are never accepted. If you searched for an appointment and came up empty, Fast Passport Center's registered courier channel is your fastest next step. No appointment. No waiting in line at the federal building. Processing as fast as 2–3 business days.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Get Started <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="rounded-lg overflow-hidden border border-gray-200">
          <div className="grid grid-cols-3 bg-[#1A365D] text-white">
            <div className="p-4 text-sm font-semibold text-white/50">Feature</div>
            <div className="p-4 text-sm font-semibold text-center border-l border-white/10">
              <i className="ri-government-line mr-1.5"></i>Regional Passport Agency
            </div>
            <div className="p-4 text-sm font-semibold text-center border-l border-white/10 bg-[#F6C344]/15">
              <i className="ri-shield-check-line mr-1.5 text-[#F6C344]"></i>Fast Passport Center
            </div>
          </div>

          {rows.map((row, i) => (
            <div
              key={i}
              className={`grid grid-cols-3 border-t border-gray-100 ${i % 2 === 0 ? "bg-white" : "bg-[#F7F8FA]"}`}
            >
              <div className="p-4 text-sm font-semibold text-[#1A365D]">{row.feature}</div>
              <div className="p-4 text-sm text-gray-500 border-l border-gray-100 flex items-start gap-2">
                <i className="ri-close-circle-line text-red-400 flex-shrink-0 mt-0.5"></i>
                <span>{row.agency}</span>
              </div>
              <div className="p-4 text-sm text-gray-700 border-l border-gray-100 flex items-start gap-2 bg-[#F6C344]/5">
                <i className="ri-checkbox-circle-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                <span className="font-medium">{row.fpc}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Expedited Passport <i className="ri-arrow-right-line"></i>
          </a>
          <p className="text-gray-400 text-xs mt-3">
            {regionalAgency.name} — {regionalAgency.address} — {regionalAgency.distance}
          </p>
        </div>
      </div>
    </section>
  );
}